import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute inset-0 pointer-events-none overflow-hidden" }
const _hoisted_2 = { class: "max-w-5xl mx-auto text-center relative z-10" }
const _hoisted_3 = { class: "text-3xl md:text-4xl font-bold mb-8" }
const _hoisted_4 = { class: "galaxy-text-gradient" }

import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'AboutSection',
  props: {
    isDark: { type: Boolean }
  },
  setup(__props: any) {



const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    id: "about",
    class: _normalizeClass(["section-padding relative overflow-hidden transition-colors duration-500", __props.isDark ? 'galaxy-section-alt-dark' : 'galaxy-section-alt-light'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["absolute top-0 right-0 w-96 h-96 rounded-full blur-3xl opacity-10", __props.isDark ? 'bg-nebula-purple' : 'bg-primary-300'])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["absolute bottom-0 left-0 w-80 h-80 rounded-full blur-3xl opacity-10", __props.isDark ? 'bg-nebula-cyan' : 'bg-accent-200'])
      }, null, 2)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('about.sectionTitle')), 1)
      ]),
      _createElementVNode("p", {
        class: _normalizeClass(["text-lg leading-relaxed mb-12 max-w-3xl mx-auto", __props.isDark ? 'text-galaxy-200' : 'text-gray-600'])
      }, _toDisplayString(_unref(t)('about.description')), 3),
      _createElementVNode("div", {
        class: _normalizeClass(["galaxy-card p-8 md:p-12 max-w-2xl mx-auto relative", __props.isDark ? 'border-t-4 border-nebula-pink' : 'border-t-4 border-secondary'])
      }, [
        _createElementVNode("h3", {
          class: _normalizeClass(["text-2xl font-bold mb-4", __props.isDark ? 'text-nebula-pink' : 'text-secondary'])
        }, _toDisplayString(_unref(t)('about.mission')), 3),
        _createElementVNode("p", {
          class: _normalizeClass(["text-lg leading-relaxed", __props.isDark ? 'text-galaxy-200' : 'text-gray-600'])
        }, _toDisplayString(_unref(t)('about.missionText')), 3)
      ], 2)
    ])
  ], 2))
}
}

})